import http from "../http";

// export all dashboard services 
export const fmProjectsService = {
    getProjectListService,
    getProjectInvoicesListService,
    getProjectInvoiceDetailsService,
    splitInvoiceService,
    uploadInvoiceAttachmentService,
    resyncProjectInvoiceDetailsService,
    updateInvoiceService,
    releaseInvoiceService,
    unreleaseInvoiceService,
    uploadPdfForInvoiceService,
    uploadPdfForChangeOrderService,

    getProjectExpensesService,
    addProjectEstimatedExpenseService,
    updateProjectEstimatedExpenseService,
    deleteProjectEstimatedExpenseService,
    confirmProjectExpenseService,
    uploadExpenseService,
    uploadExpenseAttachmentService,
    expenseDetailsService,
    getUnverifiedExpensesListService,
    compareUnverifiedExpenseService,
    
    projectOverviewDetailsService,
    getProjectTimelineListService,
    updateTaskConnectionsService,
    getProjectTasksService,
    projectOverviewTaskDetailsService,
    projectMilestonesService,
    getProjectPhasesList,
    addProjectTaskService,
    updateProjectTaskService,
    deleteProjectTaskService,
    inlineUpdateProjectTaskService,
    getChangeOrderService,
    getChangeOrderItemsService,
    createChangeOrderService,
    saveChangeOrderService,
    getChangeOrderDetailsService,
    getChangeOrderTermsService,
    saveChangeOrderNotesService,
    saveChangeOrderIntroService,
    uploadChangeOrderPdfService,
    adjustChangeOrderService,

    changeOrderAttachmentListService,
    removeChangeOrderAttachmentService,
    exportChangeOrderService,
    deleteChangeOrderService,
    duplicateChangeOrderService,
    getCOPaymentScheduleService,
    updateCOPaymentScheduleService,
    rfpListService,
    createRfpService,
    updateRfpService,
    unreleaseChangeOrder,
    rearrangeProjectOverviewDetailsService,
    generateZip,
    addCreditService,
    getAvailableTasksService
}
// get projects list service
function getProjectListService(payload: any) {
    return http.post(`${process.env.REACT_APP_BASE_URL}/finance/${payload?.id}/projects/?page=${payload?.page}&perPage=${payload?.perPage}`,{
      filters: payload?.filters,
      sort: payload?.sort
    });
}

// get project-center invoices list Service
function getProjectInvoicesListService(payload: {id:string, dealId: string}) {
  return http.get(`${process.env.REACT_APP_BASE_URL}/finance/${payload?.id}/project/${payload?.dealId}/invoices`);
}

// get project-center invoice details service
function getProjectInvoiceDetailsService(payload: {id:string, dealId: string, invoiceId: string}) {
  return http.get(`${process.env.REACT_APP_BASE_URL}/finance/${payload?.id}/project/${payload?.dealId}/invoice/${payload?.invoiceId}`);
}

// split invoice service
function splitInvoiceService(payload: {id:any, dealId: string, invoiceId: string, data: any}){
  return http.put(`${process.env.REACT_APP_BASE_URL}/finance/${payload?.id}/project/${payload?.dealId}/invoice/${payload?.invoiceId}/split`, {
    ...payload?.data
  });
}

// update attachments for estimated expense
function uploadInvoiceAttachmentService(payload: {id: string, dealId: string, invoiceId: string, formData: any}) {
  return http.post(`${process.env.REACT_APP_BASE_URL}/finance/${payload?.id}/project/${payload?.dealId}/invoice/${payload?.invoiceId}/attachment`,
    payload?.formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
}

// resync invoice details service
function resyncProjectInvoiceDetailsService(payload: {id:string, dealId: string, invoiceId: string}) {
  return http.put(`${process.env.REACT_APP_BASE_URL}/finance/${payload?.id}/project/${payload?.dealId}/invoice/${payload?.invoiceId}/sync`);
}

// update invoice service
function updateInvoiceService(payload: {id:any, dealId: string, invoiceId: string, data: any}){
  return http.put(`${process.env.REACT_APP_BASE_URL}/finance/${payload?.id}/project/${payload?.dealId}/invoice/${payload?.invoiceId}`, {
    ...payload?.data
  });
}

function releaseInvoiceService(payload: {id:any, dealId: string, invoiceId: string}){
  return http.put(`${process.env.REACT_APP_BASE_URL}/finance/${payload?.id}/project/${payload?.dealId}/invoice/${payload?.invoiceId}/release`);
}

function unreleaseInvoiceService(payload: {id:any, dealId: string, invoiceId: string}){
  return http.put(`${process.env.REACT_APP_BASE_URL}/finance/${payload?.id}/project/${payload?.dealId}/invoice/${payload?.invoiceId}/unrelease`);
}

function uploadPdfForInvoiceService(payload: any){
  return http.post(`${process.env.REACT_APP_BASE_URL}/finance/${payload?.pmId}/project/${payload?.dealId}/invoice/${payload?.invoiceId}/upload`,
    payload?.data,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
}

function uploadPdfForChangeOrderService(payload: any){
  return http.post(`${process.env.REACT_APP_BASE_URL}/finance/project/change-order/${payload?.id}/sign`,
    payload?.data,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
}

// Expenses
function getProjectExpensesService(payload: {id:string, dealId: string}) {
  return http.get(`${process.env.REACT_APP_BASE_URL}/finance/project/${payload?.dealId}/expenses`);
}

// add new estimated expense
function addProjectEstimatedExpenseService(payload: {dealId: string, data: any}) {
  return http.post(`${process.env.REACT_APP_BASE_URL}/finance/project/${payload?.dealId}/expense`, payload?.data);
}

// update estimated expense
function updateProjectEstimatedExpenseService(payload: {dealId: string, data: any}) {
  return http.put(`${process.env.REACT_APP_BASE_URL}/finance/project/${payload?.dealId}/expense/${payload?.data?.id}`, payload?.data);
}

// delete estimated expense
function deleteProjectEstimatedExpenseService(payload: {dealId: string, expenseId: any}) {
  return http.delete(`${process.env.REACT_APP_BASE_URL}/finance/project/${payload?.dealId}/expense/${payload?.expenseId}`);
}

// update estimated expense
function confirmProjectExpenseService(payload: {dealId: string, data: any}) {
  return http.put(`${process.env.REACT_APP_BASE_URL}/finance/project/${payload?.dealId}/expense/${payload?.data?.id}`, payload?.data);
}

// update estimated expense
function uploadExpenseService(payload: {dealId: string, formData: any}) {
  return http.post(`${process.env.REACT_APP_BASE_URL}/finance/project/${payload?.dealId}/expense/upload`,
    payload?.formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
}

// update attachments for estimated expense
function uploadExpenseAttachmentService(payload: {dealId: string, expenseId: string, formData: any}) {
  return http.post(`${process.env.REACT_APP_BASE_URL}/finance/project/${payload?.dealId}/expense/${payload?.expenseId}/attachment`,
    payload?.formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
}

// expense details
function expenseDetailsService(payload: {dealId: string, expenseId: any}) {
  return http.get(`${process.env.REACT_APP_BASE_URL}/finance/project/${payload?.dealId}/expense/${payload?.expenseId}`);
}

// expense details
function getUnverifiedExpensesListService(payload: {dealId: string}) {
  return http.get(`${process.env.REACT_APP_BASE_URL}/finance/project/${payload?.dealId}/unverified-expenses`);
}

// expense details
function compareUnverifiedExpenseService(payload: {dealId: string, expenseId: string, data: any}) {
  return http.post(`${process.env.REACT_APP_BASE_URL}/finance/project/${payload?.dealId}/expense/${payload?.expenseId}/compare`, {
    ...payload?.data
  });
}

// get project overview details service
function projectOverviewDetailsService(payload: any){
  // 447abd28-e8ec-4326-b638-afdca1c0658b
  // use this id for testing. later replace it with logged in user id
    return http.post(`${process.env.REACT_APP_BASE_URL}/finance/v2/${payload?.id}/project/${payload?.projectId}/overview`, {
      sort: {
  
      },
      tab: payload?.tab? payload?.tab: "",
      filters: payload?.filters
    });
  }

// get project overview details service
function rearrangeProjectOverviewDetailsService(payload: any) {
  return http.post(`${process.env.REACT_APP_BASE_URL}/finance/${payload?.id}/project/${payload?.projectId}/item-sequence`, {
    task: payload?.tasks ? payload?.tasks : []
  });
}

// get project tasks list for gantt chart service
// change
function getProjectTimelineListService(payload: any){
  return http.get(`${process.env.REACT_APP_BASE_URL}/finance/${payload?.id}/project/${payload?.projectId}/${payload?.timeline?'timeline-listing': 'timeline'}`);
}

// update project task connections for gantt chart service
// change
function updateTaskConnectionsService(payload: any){
  return http.put(`${process.env.REACT_APP_BASE_URL}/finance/${payload?.id}/project/${payload?.projectId}${payload?.timeline?'/timeline':''}/task/${payload?.taskId}/connections`, {
    connections: payload?.data
  });
}

// get phase-wise tasks list for a project service
// change
function getProjectTasksService(payload: any){
  return http.get(`${process.env.REACT_APP_BASE_URL}/finance/${payload?.id}/project/${payload?.projectId}${payload?.timeline?'/timeline':''}/tasks`);
}

// get project overview task details service
// change
function projectOverviewTaskDetailsService(payload: any){
  return http.get(`${process.env.REACT_APP_BASE_URL}/finance/${payload?.id}/project/${payload?.projectId}${payload?.timeline?'/timeline':''}/task/${payload?.taskId}`);
}

// get valid project milestones to link to task
function projectMilestonesService(payload: any){
  return http.post(`${process.env.REACT_APP_BASE_URL}/finance/project/${payload?.projectId}${payload?.timeline?'/timeline':''}/unreleased-invoices`);
}

// get all project phases service
function getProjectPhasesList(payload: any) {
    return http.get(`${process.env.REACT_APP_BASE_URL}/finance/${payload?.id}/project/${payload?.projectId}/phases`);
}

// Add project task service
// change
function addProjectTaskService(payload: any) {
  return http.post(`${process.env.REACT_APP_BASE_URL}/finance/${payload?.id}/project/${payload?.projectId}${payload?.timeline?'/timeline':''}/task`, {
    ...payload?.taskObj
  })
}

// update project task service
// change
function updateProjectTaskService(payload: any) {
  return http.put(`${process.env.REACT_APP_BASE_URL}/finance/${payload?.id}/project/${payload?.projectId}${payload?.timeline?'/timeline':''}/task/${payload?.taskId}`, {
    ...payload?.taskObj
  })
}

// delete project task service
// change
function deleteProjectTaskService(payload: any) {
  return http.delete(`${process.env.REACT_APP_BASE_URL}/finance/${payload?.id}/project/${payload?.projectId}${payload?.timeline?'/timeline':''}/task/${payload?.taskId}`);
}

// inline update project task service
function inlineUpdateProjectTaskService(payload: any) {
  return http.put(`${process.env.REACT_APP_BASE_URL}/finance/${payload?.id}/project/${payload?.dealId}/timeline/task/${payload?.taskId}/inline-update`, {
    ...payload?.data
  })
}

// get change-order Service
function getChangeOrderService(payload: {dealId:any, sort:any}) {
  return http.post(`${process.env.REACT_APP_BASE_URL}/finance/project/${payload?.dealId}/change-order/list`, {
    sort: payload.sort
  });
}

// get change-order items
function getChangeOrderItemsService(payload:any) {
  return http.post(`${process.env.REACT_APP_BASE_URL}/finance/change-order/get-item`, payload);
}

// create change order
function createChangeOrderService(dealId:any) {
  return http.post(`${process.env.REACT_APP_BASE_URL}/finance/project/${dealId}/change-order`);
}

// save change order
function saveChangeOrderService(change_order_id:any, payload:any) {
  return http.put(`${process.env.REACT_APP_BASE_URL}/finance/project/change-order/${change_order_id}/items`, payload);
}

// get change order details
function getChangeOrderDetailsService(change_order_id:any) {
  return http.get(`${process.env.REACT_APP_BASE_URL}/finance/project/change-Order/${change_order_id}`);
}

// get change order terms
function getChangeOrderTermsService(change_order_id:any) {
  return http.get(`${process.env.REACT_APP_BASE_URL}/finance/change-order/${change_order_id}/terms`);
}

// save change order notes
function saveChangeOrderNotesService(change_orde_id:any,payload:any) {
  return http.put(`${process.env.REACT_APP_BASE_URL}/finance/change-order/${change_orde_id}/notes`, payload);
}

// save change order Intro
function saveChangeOrderIntroService(payload:any) {
  return http.post(`${process.env.REACT_APP_BASE_URL}/finance/change-order/${payload?.change_order_id}/terms`, payload?.data)
}

// upload change order pdf service
function uploadChangeOrderPdfService(payload:{formData:any, id:any}) {
  return http.post(`${process.env.REACT_APP_BASE_URL}/finance/project/change-order/${payload?.id}/attachment`,
  payload?.formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  )
}

// adjust change order
function adjustChangeOrderService(payload:any) {

  if(payload?.data){
    return http.post(`${process.env.REACT_APP_BASE_URL}/finance/project/change-order/${payload?.change_order_id}/adjust`, {
      ...payload?.data
    });
  }

  return http.post(`${process.env.REACT_APP_BASE_URL}/finance/project/change-order/${payload?.change_order_id}/adjust`);
}

// uploaded change order doc list service
function changeOrderAttachmentListService(change_order_id:any) {
  return http.get(`${process.env.REACT_APP_BASE_URL}/finance/project/change-order/${change_order_id}/attachment`)
}

// remove uploaded change order attachment service
function removeChangeOrderAttachmentService(attachmentId:any) {
  return http.delete(`${process.env.REACT_APP_BASE_URL}/finance/project/change-order/attachment/${attachmentId}`)
}

// view as pdf and release service
function exportChangeOrderService(change_order_id:any,payload:any) {
  return http.post(`${process.env.REACT_APP_BASE_URL}/finance/project/change-order/${change_order_id}/pdf`, payload)
}

// delete change order service
function deleteChangeOrderService(change_order_id:any) {
  return http.delete(`${process.env.REACT_APP_BASE_URL}/finance/project/change-order/${change_order_id}`)
}

// duplicate change order service
function duplicateChangeOrderService(change_order_id:any) {
  return http.post(`${process.env.REACT_APP_BASE_URL}/finance/project/change-order/${change_order_id}/duplicate`)
}

// get change order payment schedule 
function getCOPaymentScheduleService(change_order_id:any) {
  return http.get(`${process.env.REACT_APP_BASE_URL}/finance/get-payment-schedule/${change_order_id}`)
}

// get change order payment schedule 
function updateCOPaymentScheduleService(payload:any) {
  return http.post(`${process.env.REACT_APP_BASE_URL}/finance/save-payment-schedule`, {
    ...payload
  })
}

// Create rfp service
function createRfpService(payload: any) {
  return http.post(`${process.env.REACT_APP_BASE_URL}/finance/project/${payload.dealId}/rfp/${payload.id}`, payload.body)
}

// rfp listing service
function rfpListService(payload: {dealId:any, sort:any}) {
  return http.post(`${process.env.REACT_APP_BASE_URL}/finance/project/${payload?.dealId}/rfp`, {
    sort: payload.sort
  });
}

// rfp listing service
function updateRfpService(payload: any) {
  return http.put(`${process.env.REACT_APP_BASE_URL}/finance/project/${payload?.dealId}/rfp/${payload?.id}`, payload?.body)
}

// Unrelease change order
function unreleaseChangeOrder(change_orde_id:any) {
  return http.put(`${process.env.REACT_APP_BASE_URL}/finance/project/change-order/${change_orde_id}/unrelease`)
}

// Generate zip 
function generateZip(payload:any) {
  return http.post(`${process.env.REACT_APP_BASE_URL}/finance/project/rfp/${payload?.id}/generate-rfp-zip`, payload?.body)
}

// add credit note service
function addCreditService(payload: {dealId: string, data: any}) {
  return http.post(`${process.env.REACT_APP_BASE_URL}/finance/project/${payload?.dealId}/add-credits`, payload?.data);
}

// get available tasks service
function getAvailableTasksService(payload: {dealId: string}) {
  return http.get(`${process.env.REACT_APP_BASE_URL}/finance/v2/project/${payload?.dealId}/available-tasks`);
}
